import HomeAutomationLayout from "./HomeAutomationLayout";
import HomeAutomationPage from "./pages/HomeAutomationPage";
import HomeAutomationAppointmentDashboardPage from "./pages/HomeAutomationAppointmentPage";

export const homeAutomationRoutes = {
  path: "home-automation",
  // name: "HomeAutomation",
  component: HomeAutomationLayout,
  children: [
    {
      name: "HomeAutomationPage",
      path: "dashboard",
      component: HomeAutomationPage,
    },
    {
      name: "HomeAutomationAppointmentDashboardPage",
      path: "appointment",
      component: HomeAutomationAppointmentDashboardPage,
    },
  ]
};
